// import useEventCallback from '@restart/hooks/useEventCallback';
import { useEffect } from 'react';
const HandlerMap = new Map([['CANCEL_LAST_POINT', new Set()], ['FINISH_OPEN_TRACE', new Set()], ['DELETE_SELECTED_TRACE', new Set()]]);
export function addHandler(command, handler) {
  const handlers = HandlerMap.get(command);
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}
export function trigger(command, event = null) {
  const handlers = HandlerMap.get(command);

  if (handlers.size) {
    // iterate first in case a handler triggers an update that sets a new handler
    const allHandlers = Array.from(handlers);

    for (const handler of allHandlers) {
      handler(event);
    }
  }

  return undefined;
}
export function useCommandHandler(cmd, handler) {
  useEffect(() => addHandler(cmd, handler), [cmd, handler]);
}